import styled from "styled-components";

export const DesignContainer = styled.div`
  border-radius: ${({ borderRadius = 13 }) => `${borderRadius}px`};
  display: flex;
  justify-content: center;

  ${({ hasHover, theme }) =>
    hasHover &&
    `
    &:hover {
      outline-offset: 3px;
      outline: 6px solid ${theme.border.brand}4d;
    }`}

  ${({ isSelected, theme }) =>
    isSelected &&
    `
        outline-offset: 3px;
        outline: 6px solid ${theme.border.brand}4d;
    `}
`;

export const OverviewDesignContainer = styled.div`
  border-radius: ${({ borderRadius = 13 }) => `${borderRadius}px`};
  display: flex;
  justify-content: center;

  ${({ hasHover, theme }) =>
    hasHover &&
    `
    &:hover {
      outline-offset: 3px;
      outline: 6px solid ${theme.border.brand}4d;
    }`}
`;
